module.exports = __webpack_public_path__ + "img/logo_bessac.92cf6047.svg";